<template>
    <div id="LmQmsButtonBuilderUi" class="row align-items-center">
      <hr class="w-100 mx-2">
      <h5 class="col-12">{{ $t('settings') }}</h5>
      <LmTextInput
        class="col-12 col-md-6"
        v-model="component.componentProps.name"
        @input="$emit('input', component)"
        :label="$t('name')"
        :help="$t('qms_name_button_help')"
        :placeholder="$t('name')"
      />
      <LmSelect
        class="col-12 col-md-6"
        v-model="component.componentProps.action"
        :options="{
          content: [{value: 'gotoscreen', text: 'Ir a Pantalla'}, {value: 'printticket', text: 'Asignar Turno'}]
        }"
        :help="$t('qms_action_button_help')"
        :label="$t('action')"
        @input="$emit('input', component)"
      />
      <LmSelect
        v-if="component.componentProps.action === 'gotoscreen'"
        class="col-12"
        v-model="component.componentProps.selectedScreen"
        :options="{
          content: filteredScreens
        }"
        :label="$t('select_screen')"
        :help="$t('qms_select_screen_help')"
        @input="$emit('input', component)"
      />
      <LmSelect
        v-if="component.componentProps.action === 'printticket'"
        class="col-12"
        v-model="component.componentProps.selectedProcess"
        :options="{
          content: availableProcesses
        }"
        :label="$t('select_process')"
        :help="$t('qms_select_process_help')"
        @input="$emit('input', component)"
      />
      <hr class="w-100 mx-2">
      <h5 class="col-12">{{ $t('visual_attributes') }}</h5>
      <LmColorPicker
        class="form-group col-12 col-md-6"
        :showFallback="true"
        shapes="squares"
        :label="$t('color')"
        :help="$t('color_help')"
        v-model="component.componentProps.buttonColor"
      />
      <LmColorPicker
        class="form-group col-12 col-md-6"
        :showFallback="true"
        shapes="squares"
        :label="$t('background_color')"
        :help="$t('color_help')"
        v-model="component.componentProps.buttonBgColor"
      />
      <LmSelect
        class="col-12 col-md-8"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <LmSelect
        class="col-12 col-md-4"
        v-model="component.componentProps.buttonAlign"
        :options="buttonAlignOptions"
        :label="$t('align')"
        :help="$t('align_help')"
        @input="$emit('input', component)"
      />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmButton from '@/components/form/elements/LmButton'
import LmColorPicker from '@/components/form/elements/LmColorPicker'

export default {
  data () {
    return {
      component: {},
      buttonAlignOptions: {
        content: [
          { value: 'center', text: this.$t('centered') },
          { value: 'left', text: this.$t('left') },
          { value: 'right', text: this.$t('right') }
        ]
      },
      deleteTypeOptions: {
        content: [{
          value: 'put',
          text: this.$t('logic')
        }, {
          value: 'delete',
          text: this.$t('permanent')
        }]
      }
    }
  },
  components: {
    LmTextInput,
    LmSelect,
    LmCheckbox,
    LmButton,
    LmColorPicker
  },
  props: {
    componentData: {
      type: Object,
      default: () => (
        {
          class: '',
          componentName: 'LmButton',
          componentProps: {
            isVisible: true,
            name: 'gotoscreen',
            action: '',
            currentScreenId: '',
            selectedScreen: '',
            selectedProcess: '',
            buttonClass: 'btn-primary',
            buttonBgColor: '',
            buttonColor: '',
            buttonAlign: ''
          }
        }
      )
    },
    screens: {
      type: Array
    },
    availableProcesses: {
      type: Array
    }
  },
  computed: {
    // Filtro las screens para excluir la actual y mostrar el resto
    filteredScreens () {
      return this.screens?.map(s => {
        return {
          value: s.id,
          text: s.title
        }
      }).filter(s => s?.value !== this.component.componentProps.currentScreenId)
    }
  },
  methods: {
  },
  created () {
    this.component = this.componentData
  }
}
</script>
